import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './components/error/error.component';
import { validateAccessGuard } from './core/guards/validate-access/validate-access.guard';
import { CompanyDataComponent } from './pages/company-data/company-data.component';
import { MainComponent } from './pages/main/main.component';
import { VerifyPhoneComponent } from './pages/verify-phone/verify-phone.component';
import { requireQueryParamsGuard } from './core/guards/require-params/require-params.guard';
import { TaxFolderComponent } from './pages/tax-folder/tax-folder.component';

const routes: Routes = [
	{
		path: 'home',
		component: MainComponent,
		canActivate: [requireQueryParamsGuard],
		children: [
			{
				path: 'company-data',
				component: CompanyDataComponent,
				canActivate: [validateAccessGuard],
			},
			{
				path: 'verify-phone',
				component: VerifyPhoneComponent,
				canActivate: [validateAccessGuard],
			},
			{
				path: 'tax-folder',
				component: TaxFolderComponent,
				canActivate: [validateAccessGuard],
			},
			{
				path: 'tax-folder-warning',
				component: ErrorComponent,
				canActivate: [validateAccessGuard],
			},
		],
	},
	{
		path: 'error',
		component: ErrorComponent,
	},
	{
		path: '**',
		redirectTo: 'home',
		pathMatch: 'full',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			scrollPositionRestoration: 'top',
		}),
	],
	exports: [RouterModule],
	providers: [],
})
export class AppRoutingModule {}
